// extracted by mini-css-extract-plugin
export default {"applianceContainer":"ApplianceOverview_applianceContainer__i6zEr","addApplianceButton":"ApplianceOverview_addApplianceButton__IEIou"};